import React from 'react';
import './plans-table.scss';
import { PLANS_TABLE } from '../../constants/plan-table';
import checkBlue from 'assets/images/svg/icon-check-blue-mobile.svg';
import grayLine from 'assets/images/svg/new-plan/plan-table/gray-line.svg';
import { Button } from 'components';
import { PLANS_TABLE_HIGH } from 'domains/new-plan/constants/plan-table-high';
import lines from 'assets/images/svg/new-plan/plan-table/lines.svg';
import { useAllPlansTable } from 'domains/new-plan/hooks/use.-plans-table';
import {
  getFirstPlanValue,
  getSecondPlanValue,
} from 'domains/new-plan/utils/datalayer';
import { useLocation } from 'react-router-dom';
import AutoefectivoPriceEnums from 'domains/new-plan/enums/autoefectivo-prices';

interface PlansTableProps {
  isLowerPrice: boolean;
  isTaxi: boolean;
}

const PlansTable: React.FC<PlansTableProps> = (props: PlansTableProps) => {
  const { isLowerPrice, isTaxi } = props;
  const location = useLocation();
  const { pathname } = location;
  const PLAN = isLowerPrice ? PLANS_TABLE : PLANS_TABLE_HIGH;

  const firstValue = getFirstPlanValue(pathname);
  const secondValue = getSecondPlanValue(pathname);

  const priceLowest = isTaxi
    ? AutoefectivoPriceEnums.taxiLowest
    : isLowerPrice
    ? AutoefectivoPriceEnums.bcpLowest
    : AutoefectivoPriceEnums.lowest;

  const priceHighest = isTaxi
    ? AutoefectivoPriceEnums.taxiHighest
    : isLowerPrice
    ? AutoefectivoPriceEnums.bcpHighest
    : AutoefectivoPriceEnums.highest;

  const { handleSelectedPlan } = useAllPlansTable();
  return (
    <div className="plans-table" id="plans-table">
      <div className="plans-table__container">
        <h3 className="plans-table__container__title">
          <b>¡El seguro que necesitas para tu carro!</b>
          <br />
          Pagarás poco, pero recibirás mucho
        </h3>
        <div className="plans-table__container__table">
          <div className="plans-table__container__table__head">
            <div className="content">
              <img src={lines} />
            </div>
            <div className="content">
              <p className="content__title">Para tu carro y más</p>
              <p className="content__sub-title">
                Desde <span>S/{priceHighest}</span> al mes
              </p>
              <p className="content__footer">incluye IGV </p>
              <Button
                label="Solicítalo"
                onClick={() => handleSelectedPlan(firstValue)}
              />
            </div>
            <div className="content">
              <p className="content__title">Para tu carro </p>
              <p className="content__sub-title">
                Desde <span>S/{priceLowest}</span> al mes
              </p>
              <p className="content__footer">incluye IGV </p>
              <Button
                label="Solicítalo"
                onClick={() => handleSelectedPlan(secondValue)}
              />
            </div>
          </div>
          <div className="plans-table__container__table__line">
            Lista de coberturas y beneficios
          </div>
          <div className="plans-table__container__table__body">
            {PLAN.map((plan) => {
              return (
                <div className="content" key={plan.id}>
                  <div className="title">{plan.description}</div>
                  <div className="row">
                    <div className="column">{plan.description}</div>
                    <div className="column">
                      {plan.all ? (
                        <img src={checkBlue} />
                      ) : (
                        <img src={grayLine} />
                      )}
                      <p>
                        {plan.until && <span>Hasta </span>} {plan.allAmount}
                      </p>
                    </div>
                    <div className="column">
                      {plan.alone ? (
                        <img src={checkBlue} />
                      ) : (
                        <img src={grayLine} />
                      )}
                      <p>{plan.aloneAmount}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {isTaxi && (
            <div className="plans-table__container__table__footer">
              (*) Toda indemnización estará supeditada a una evaluación de un
              especialista de Pacifico seguros.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlansTable;
